import { useOutletContext } from "react-router"
import { AutomationRunsList } from "../../../../Automations/Runs"
import { TAutomation } from "../../../../Automations/store"

export default function AutomationRunsPage() {
	const context = useOutletContext<{
		automationId: string
		automation: TAutomation
	}>()

	return (
		<AutomationRunsList
			automationIds={[Number(context.automationId)]}
			title="Runs"
			pageKey={`automation-${context.automationId}-runs`}
		/>
	)
}
